import { useCallback, useReducer } from 'react';
import { DateObjectUnits, DateTime } from 'luxon';

function useViewDate({ initalView }: { initalView?: DateTime }): {
  leftViewDate: DateTime;
  rightViewDate: DateTime;
  updateLeftViewDate: (date: DateTime | DateObjectUnits) => void;
  updateRightViewDate: (date: DateTime | DateObjectUnits) => void;
} {
  const initLeft = (initalView || DateTime.now()).startOf('month');
  const initRight = initLeft.plus({ months: 1 }).startOf('month');
  const initialState = { left: initLeft, right: initRight };
  function viewDateReducer(
    state: typeof initialState,
    action: { left: DateTime | DateObjectUnits } | { right: DateTime | DateObjectUnits },
  ) {
    if ('left' in action) {
      const left = DateTime.isDateTime(action.left) ? action.left : state.left.set(action.left);
      return { left, right: left.plus({ months: 1 }).startOf('month') };
    }
    const right = DateTime.isDateTime(action.right) ? action.right : state.right.set(action.right);
    return { left: right.minus({ months: 1 }).startOf('month'), right };
  }
  const [{ left: leftViewDate, right: rightViewDate }, updateViewDate] = useReducer(viewDateReducer, initialState);
  const updateLeftViewDate = useCallback((date: DateTime | DateObjectUnits) => updateViewDate({ left: date }), []);
  const updateRightViewDate = useCallback((date: DateTime | DateObjectUnits) => updateViewDate({ right: date }), []);
  return {
    leftViewDate,
    rightViewDate,
    updateLeftViewDate,
    updateRightViewDate,
  };
}

export default useViewDate;
